import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { Auto, Version } from '../../../comun/model/autos.model';
import { CaDatepickerComponent } from '@global-front-components/ui/datepicker';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { PreguntaCatalogo, RespuestaCatalogo } from '../../../comun/model/catalogo.model';
import { Pregunta } from '../../../comun/model/poliza.model';

@Component({
	selector: 'app-uso-vehiculo',
	standalone: true,
	imports: [
		CommonModule,
		CaInputDirective,
		CaLabel,
		CaFormFieldComponent,
		TranslateModule,
		CaDatepickerComponent,
		ReactiveFormsModule,
		CaSelectComponent,
		CaError
	],
	templateUrl: './uso-vehiculo.component.html',
	styleUrls: ['./uso-vehiculo.component.scss']
})
export class UsoVehiculoComponent implements OnInit {
	@Input() version: Version;
	@Input() auto: Auto;
	@Input() preguntasCatalogo: PreguntaCatalogo[];
	@Input() preguntasPoliza: Pregunta[] = [];
	@Input() form: FormGroup;

	usosVehiculo: RespuestaCatalogo[];
	companiasSeguro: RespuestaCatalogo[];

	constructor(private fb: FormBuilder) {}

	ngOnInit(): void {
		this.buildForm();
		this.extraerInfoCatalogo();
	}

	buildForm(): void {
		const fPrimeraMatriculacion = this.auto?.fecMatriculacionAprox || '';
		const matricula = this.auto?.matricula || '';
		const bastidor = this.auto?.bastidor || '';
		
		this.form.addControl('preg_7320',this.fb.control({ value: this.version?.marca, disabled: true}, [Validators.required]));
		this.form.addControl('preg_7321',this.fb.control({ value: this.version?.modelo, disabled: true}, [Validators.required]));
		this.form.addControl('preg_1178',this.fb.control({ value: fPrimeraMatriculacion, disabled: fPrimeraMatriculacion !== '' }, [Validators.required]));
		this.form.addControl('preg_1173',this.fb.control({ value: bastidor, disabled: bastidor !=='' }, [Validators.required]));
		this.form.addControl('preg_2125',this.fb.control({ value: this.version?.version, disabled: true}, [Validators.required]));
		
		const valorUso = this.preguntasPoliza?.find(p => p.idPregunta === 2123)?.respuesta || '';
		this.form.addControl('preg_2123',this.fb.control(valorUso, [Validators.required]));
		const valorCompania = this.preguntasPoliza?.find(p => p.idPregunta === 2209)?.respuesta || '';
		this.form.addControl('preg_2209', this.fb.control(valorCompania));
		const numPoliza = this.preguntasPoliza?.find(p => p.idPregunta === 2210)?.respuesta || '';
		this.form.addControl('preg_2210', this.fb.control(numPoliza));

		//preguntas que no vienen en el formulario, las agregamos para que se envien al backend
		this.form.addControl('preg_2120', this.fb.control(this.version?.combustible));
		this.form.addControl('preg_2143', this.fb.control(this.version?.categoriaVehi));
		this.form.addControl('preg_2097', this.fb.control(this.version?.codTipoVehi));
		this.form.addControl('preg_2121', this.fb.control(this.version?.potenciaVehi));
		this.form.addControl('preg_2122', this.fb.control(this.version?.cilindrada));
		this.form.addControl('preg_2087', this.fb.control(this.version?.valorVehi / 100));

		this.form.addControl('preg_2196',this.fb.control( "1"));

		//preguntas sin presencia en catalogo, son solo visuales
		this.form.addControl('preg_matricula',this.fb.control({ value: matricula, disabled: matricula !=='' }, [Validators.required]));
	}

	extraerInfoCatalogo(): void {
		if (!this.preguntasCatalogo) {
			return;
		}
		const preguntaUso = this.preguntasCatalogo?.find(p => p.idPregunta === 2123);
		const preguntaCompania = this.preguntasCatalogo?.find(p => p.idPregunta === 2209);
		this.usosVehiculo = preguntaUso?.respuestas;
		this.companiasSeguro = preguntaCompania?.respuestas;
	}
}
